$(() => {
  const formControl = $('.form-control');

  formControl.on('focus blur', function (e) {
    $(this).parents('.form-group').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
  }).trigger('blur');

  formControl.change(() => {
    setTimeout(() => {
      if ($('input:-webkit-autofill')) {
        $('input:-webkit-autofill').each(function () {
          if ($(this).val() !== '1') {
            $(this).parent('.form-group').addClass('focused');
          }
        });
      }
    }, 2);
  });

  /**
   * Used to remove error class on focus
   */
  $('.error input, .error .ui.dropdown').on('blur', function () {
    $('.ui.dropdown').dropdown({
      onChange() {
        $(this).closest('.field').removeClass('error');
      },
    });

    if ($(this).val().trim().length) {
      $(this).closest('.field').removeClass('error');
    }
  });
});
